import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Checkbox, FormControlLabel, Link } from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { getJsonResult, post } from "../../services/FetchServices";
import PurchaseOrderRelease from "../../types/PurchaseOrderRelease";
import SearchPurchaseOrderRelease from "../../types/SearchPurchaseOrderRelease";
import { DropDown } from "../dropDown/DropDown";

interface CreatePurchaseOrderProps {
  searchPurchaseOrder: SearchPurchaseOrderRelease;
  navigatedBack: boolean;
}

const SearchPurchaseOrderForOrderReleasePage: React.FC = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cityValues, setCityValues] = useState([]);
  const [checkedExculdeCanPo, setCheckedExculdeCanPo] = useState(true);
  const [checkedExcludePoNoQty, setCheckedExcludePoNoQty] = useState(true);
  const [purchaseOrderId, setPurchaseOrderId] = useState("");
  const [dialogContent, setDialogContent] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [openAlert, setAlertOpen] = useState(false);
  const [navigatedBack, setNavigatedBack] = useState(
    (location?.state as CreatePurchaseOrderProps)?.navigatedBack || false,
  );
  const [destinationDc, setDestinationDc] = useState("");
  const [freightTerms, setFreightTerms] = useState("");
  const searchPurchaseOrder = (location?.state as CreatePurchaseOrderProps)
    ?.searchPurchaseOrder;
  const [earlyPickupOnOrAfter, setEarlyPickupOnOrAfter] = useState<
    string | null
  >(null);
  const [latePickupOnOrAfter, setLatePickupOnOrAfter] = useState<string | null>(
    null,
  );
  const [earlyDeliveryOnOrAfter, setEarlyDeliveryOnOrAfter] = useState<
    string | null
  >(null);
  const [lateDeliveryOnOrAfter, setLateDeliveryOnOrAfter] = useState<
    string | null
  >(null);
  const [poCreationOnOrAfter, setPoCreationOnOrAfter] = useState<string | null>(
    null,
  );
  const [earlyPickupOnOrBefore, setEarlyPickupOnOrBefore] = useState<
    string | null
  >(null);
  const [latePickupOnOrBefore, setLatePickupOnOrBefore] = useState<
    string | null
  >(null);
  const [earlyDeliveryOnOrBefore, setEarlyDeliveryOnOrBefore] = useState<
    string | null
  >(null);
  const [lateDeliveryOnOrBefore, setLateDeliveryOnOrBefore] = useState<
    string | null
  >(null);
  const [poCreationOnOrBefore, setPoCreationOnOrBefore] = useState<
    string | null
  >(null);

  const [purchaseOrderReleases, setPurchaseOrderReleases] = useState<
    PurchaseOrderRelease[]
  >([]);

  const closeAlertDialog = () => {
    setAlertOpen(false);
  };

  const handleClickToOpen = () => {
    setOpen(true);
  };

  const handleToClose = () => {
    setOpen(false);
  };

  const history = useHistory();

  const routeToPurchaseOrderManager = async (
    purchaseOrderXId: string,
    lockedUnlockedStatus: string,
  ) => {
    if (lockedUnlockedStatus === "LOCKED") {
      handleClickToOpen();
    } else {
      const hazmatCodesUrl = `${process.env.REACT_APP_BACKEND_URL}/api/itemMaster/hazmatCodes`;
      const orderReleaseUrl =
        `${process.env.REACT_APP_BACKEND_URL}/api/purchaseOrder/getPurchaseOrder?` +
        "orderBaseGid=" +
        purchaseOrderXId +
        "&vendorId=" +
        localStorage.getItem("vendorId");

      const hazmatCodesResponse = await getJsonResult(hazmatCodesUrl);
      const hazmatCodes = await hazmatCodesResponse.json();

      getJsonResult(orderReleaseUrl)
        .then((response) => response.json())
        .then((data: PurchaseOrderRelease) => {
          history.push({
            pathname: "/purchaseOrderRelease",
            state: {
              purchaseOrderRelease: data,
              hazmatCodes: hazmatCodes,
              searchPurchaseOrder: buildSearchPurchaseOrderJson(),
              navigatedBack: false,
            },
          });
        });

      history.push({
        pathname: "/purchaseOrderRelease",
        state: {
          purchaseOrderRelease: [],
          hazmatCodes: hazmatCodes,
          searchPurchaseOrder: buildSearchPurchaseOrderJson(),
          navigatedBack: false,
        },
      });
    }
  };

  const handleDestinationDc = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDestinationDc(e.target.value);
  };

  const getDcList = () => {
    setIsLoading(true);
    const orderReleaseUrl = `${process.env.REACT_APP_BACKEND_URL}/matm/dcCity/list`;

    getJsonResult(orderReleaseUrl)
      .then((response) => response.json())
      .then((data) => setCityValues(data))
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChangeExcludeCanPo = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCheckedExculdeCanPo(event.target.checked);
  };

  const handleChangeExcludePoNoQty = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCheckedExcludePoNoQty(event.target.checked);
  };

  const buildSearchPurchaseOrderJson = () => {
    let searchPurchaseOrderJson = {
      purchaseOrderXId: purchaseOrderId,
      destinationDc: destinationDc,
      freightTerms: freightTerms,
      poCreationDate: poCreationOnOrAfter,
      poCreationDateBefore: poCreationOnOrBefore,
      earlyPickupDate: earlyPickupOnOrAfter,
      earlyPickupDateBefore: earlyPickupOnOrBefore,
      latePickupDate: latePickupOnOrAfter,
      latePickupDateBefore: latePickupOnOrBefore,
      earlyDeliveryDate: earlyDeliveryOnOrAfter,
      earlyDeliveryDateBefore: earlyDeliveryOnOrBefore,
      lateDeliveryDate: lateDeliveryOnOrAfter,
      lateDeliveryDateBefore: lateDeliveryOnOrBefore,
      checkedExculdeCanPo: checkedExculdeCanPo,
      checkedExcludePoNoQty: checkedExcludePoNoQty,
    };

    return searchPurchaseOrderJson;
  };

  useEffect(() => {
    if (searchPurchaseOrder !== undefined) {
      setPurchaseOrderId(searchPurchaseOrder?.purchaseOrderXId);
      setDestinationDc(searchPurchaseOrder?.destinationDc);
      setFreightTerms(searchPurchaseOrder?.freightTerms || "");
      setEarlyPickupOnOrAfter(
        searchPurchaseOrder?.earlyPickupDate
          ? new Date(searchPurchaseOrder.earlyPickupDate).toLocaleDateString()
          : null,
      );
      setEarlyPickupOnOrBefore(
        searchPurchaseOrder?.earlyPickupDateBefore
          ? new Date(
              searchPurchaseOrder.earlyPickupDateBefore,
            ).toLocaleDateString()
          : null,
      );
      setEarlyDeliveryOnOrAfter(
        searchPurchaseOrder?.earlyDeliveryDate
          ? new Date(searchPurchaseOrder.earlyDeliveryDate).toLocaleDateString()
          : null,
      );
      setEarlyDeliveryOnOrBefore(
        searchPurchaseOrder?.earlyDeliveryDateBefore
          ? new Date(
              searchPurchaseOrder.earlyDeliveryDateBefore,
            ).toLocaleDateString()
          : null,
      );
      setLatePickupOnOrAfter(
        searchPurchaseOrder?.latePickupDate
          ? new Date(searchPurchaseOrder.latePickupDate).toLocaleDateString()
          : null,
      );
      setLatePickupOnOrBefore(
        searchPurchaseOrder?.latePickupDateBefore
          ? new Date(
              searchPurchaseOrder.latePickupDateBefore,
            ).toLocaleDateString()
          : null,
      );
      setLateDeliveryOnOrAfter(
        searchPurchaseOrder?.lateDeliveryDate
          ? new Date(searchPurchaseOrder.lateDeliveryDate).toLocaleDateString()
          : null,
      );
      setLateDeliveryOnOrBefore(
        searchPurchaseOrder?.lateDeliveryDateBefore
          ? new Date(
              searchPurchaseOrder.lateDeliveryDateBefore,
            ).toLocaleDateString()
          : null,
      );
      setPoCreationOnOrAfter(
        searchPurchaseOrder?.poCreationDate
          ? new Date(searchPurchaseOrder.poCreationDate).toLocaleDateString()
          : null,
      );
      setPoCreationOnOrBefore(
        searchPurchaseOrder?.poCreationDateBefore
          ? new Date(
              searchPurchaseOrder.poCreationDateBefore,
            ).toLocaleDateString()
          : null,
      );
      setCheckedExcludePoNoQty(searchPurchaseOrder?.checkedExcludePoNoQty);
      setCheckedExculdeCanPo(searchPurchaseOrder.checkedExculdeCanPo);

      findPurchaseOrderRelease();
    }
    getDcList();
  }, []);

  const handlePurchaseOrderId = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPurchaseOrderId(e.target.value);
  };

  const findPurchaseOrderRelease = () => {
    let searchPoJson = {};
    if (searchPurchaseOrder !== undefined && navigatedBack) {
      searchPoJson = {
        purchaseOrderId: searchPurchaseOrder.purchaseOrderXId,
        shipTo: searchPurchaseOrder.destinationDc?.split(" ")[0],
        freightTerms: searchPurchaseOrder.freightTerms,
        poCreationOnOrAfter: searchPurchaseOrder.poCreationDate,
        poCreationOnOrBefore: searchPurchaseOrder.poCreationDateBefore,
        earlyPickupOnOrAfter: searchPurchaseOrder.earlyPickupDate,
        earlyPickupOnOrBefore: searchPurchaseOrder.earlyPickupDateBefore,
        latePickupOnOrAfter: searchPurchaseOrder.latePickupDate,
        latePickupOnOrBefore: searchPurchaseOrder.latePickupDateBefore,
        lateDeliveryOnOrAfter: searchPurchaseOrder.lateDeliveryDate,
        lateDeliveryOnOrBefore: searchPurchaseOrder.lateDeliveryDateBefore,
        earlyDeliveryOnOrAfter: searchPurchaseOrder.earlyDeliveryDate,
        earlyDeliveryOnOrBefore: searchPurchaseOrder.earlyDeliveryDateBefore,
        excludeCancelPo: searchPurchaseOrder.checkedExculdeCanPo,
        excludePoNoQuantity: searchPurchaseOrder.checkedExcludePoNoQty,
      };
    } else {
      searchPoJson = {
        purchaseOrderId: purchaseOrderId,
        shipTo: destinationDc?.split(" ")[0],
        freightTerms: freightTerms,
        poCreationOnOrAfter: poCreationOnOrAfter,
        poCreationOnOrBefore: poCreationOnOrBefore,
        earlyPickupOnOrAfter: earlyPickupOnOrAfter,
        earlyPickupOnOrBefore: earlyPickupOnOrBefore,
        latePickupOnOrAfter: latePickupOnOrAfter,
        latePickupOnOrBefore: latePickupOnOrBefore,
        lateDeliveryOnOrAfter: lateDeliveryOnOrAfter,
        lateDeliveryOnOrBefore: lateDeliveryOnOrBefore,
        earlyDeliveryOnOrAfter: earlyDeliveryOnOrAfter,
        earlyDeliveryOnOrBefore: earlyDeliveryOnOrBefore,
        excludeCancelPo: checkedExculdeCanPo,
        excludePoNoQuantity: checkedExcludePoNoQty,
      };
    }
    setIsLoading(true);
    const findPurchaseOrderReleaseUrl = `${process.env.REACT_APP_BACKEND_URL}/api/purchaseOrder/search`;
    post(findPurchaseOrderReleaseUrl, searchPoJson)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            "Error occured while getting the purchase order result from the search criteria.",
          );
        }
        return response.json();
      })
      .then((data) => {
        if (data == null || data.length === 0) {
          setPurchaseOrderReleases([]);
          setAlertOpen(true);
          setDialogTitle("Warning!");
          setDialogContent("No results returned from the search criteria.");
        }
        setPurchaseOrderReleases(data);
      })
      .catch((error: Error) => {
        setAlertOpen(true);
        setDialogTitle("Error!");
        setDialogContent(error?.message);
        setPurchaseOrderReleases([]);
      })
      .finally(() => {
        setIsLoading(false);
        setNavigatedBack(false);
        if (purchaseOrderReleases?.length !== 0) {
          makeScrollableTable("#purchaseOrderReleaseTable", 650);
        }
      });
  };

  const makeScrollableTable = function (
    tableSelector: string,
    tbodyHeight: number,
  ) {
    let $table = $(tableSelector);
    let $bodyCells = $table.find("tbody tr:first").children();
    let $headCells = $table.find("thead tr:first").children();

    let headColWidth = $headCells
      .map(function () {
        return $(this).outerWidth();
      })
      .get();
    let bodyColWidth = $bodyCells
      .map(function () {
        return $(this).outerWidth();
      })
      .get();

    $table
      .find("thead tr")
      .children()
      .each(function (i, v) {
        $(v).css("width", headColWidth[i] + "px");
        $(v).css("min-width", headColWidth[i] + "px");
        $(v).css("max-width", headColWidth[i] + "px");
      });
    $table
      .find("tbody tr")
      .children()
      .each(function (i, v) {
        $(v).css("width", bodyColWidth[i] + "px");
        $(v).css("min-width", bodyColWidth[i] + "px");
        $(v).css("max-width", bodyColWidth[i] + "px");
      });

    $table.find("thead").css("display", "block");
    $table.find("tbody").css("display", "block");

    $table.find("tbody").css("height", tbodyHeight + "px");
    $table.find("tbody").css("overflow-y", "auto");
    $table.find("tbody").css("overflow-x", "hidden");
  };

  return (
    <section
      className="sectionHeadingPadding"
      tabIndex={-1}
      style={{ outline: "none" }}
    >
      <div id="searchPurchaseOrderReleasePage" className="container">
        <div id="searchPurchOrderReleaseIntro" className="intro">
          <div
            id="findPurchaseOrderReleaseHeader"
            className="section-heading mb-4"
          >
            <span
              className="section-heading-lower"
              style={{
                fontSize: "1.9rem",
                color: "#6b3a06",
                textAlign: "center",
              }}
            >
              Purchase Order Finder
            </span>
          </div>
          <div className="row mb-5">
            <div className="col-lg-11 mx-auto">
              <div
                className="bg-grey p-5 rounded "
                style={{ boxShadow: " 0px 5px 10px #91d475" }}
              >
                <div className="row">
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <TextField
                        id="purchaseOrderId"
                        label="Purchase Order ID"
                        variant="outlined"
                        className="form-control"
                        value={purchaseOrderId}
                        onChange={handlePurchaseOrderId}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <DropDown
                        elementId="destinationDc"
                        codes={cityValues}
                        value={destinationDc}
                        onChange={handleDestinationDc}
                        label="DC# CITY STATE"
                        defaultOption="ALL"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <DropDown
                        elementId="freightTerms"
                        codes={["PREPAID", "COLLECT"]}
                        value={freightTerms}
                        onChange={(e: React.ChangeEvent<{ value: unknown }>) =>
                          setFreightTerms(e.target.value as string)
                        }
                        label="Freight Terms"
                        defaultOption="None"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          disableFuture
                          label="PO Creation On or After"
                          views={["year", "month", "day"]}
                          value={poCreationOnOrAfter}
                          onChange={(date: any) => {
                            setPoCreationOnOrAfter(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              id="poCreationOnOrAfter"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          disableFuture
                          label="PO Creation On or Before"
                          views={["year", "month", "day"]}
                          value={poCreationOnOrBefore}
                          onChange={(date: any) => {
                            setPoCreationOnOrBefore(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="poCreationOnOrBefore"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Early Pickup On or After"
                          views={["year", "month", "day"]}
                          value={earlyPickupOnOrAfter}
                          onChange={(date: any) => {
                            setEarlyPickupOnOrAfter(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              id="earlyPickupOnOrAfter"
                              className="form-control"
                              {...params}
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Early Pickup On or Before"
                          views={["year", "month", "day"]}
                          value={earlyPickupOnOrBefore}
                          onChange={(date: any) => {
                            setEarlyPickupOnOrBefore(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              id="earlyPickupOnOrBefore"
                              className="form-control"
                              {...params}
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Late Pickup On or After"
                          views={["year", "month", "day"]}
                          value={latePickupOnOrAfter}
                          onChange={(date: any) => {
                            setLatePickupOnOrAfter(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="latePickupOnOrAfter"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Late Pickup On or Before"
                          views={["year", "month", "day"]}
                          value={latePickupOnOrBefore}
                          onChange={(date: any) => {
                            setLatePickupOnOrBefore(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="latePickupOnOrBefore"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Early Delivery On or After"
                          views={["year", "month", "day"]}
                          value={earlyDeliveryOnOrAfter}
                          onChange={(date: any) => {
                            setEarlyDeliveryOnOrAfter(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="earlyDeliveryOnOrAfter"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Early Delivery On or Before"
                          views={["year", "month", "day"]}
                          value={earlyDeliveryOnOrBefore}
                          onChange={(date: any) => {
                            setEarlyDeliveryOnOrBefore(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="earlyDeliveryOnOrBefore"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Late Delivery On or After"
                          views={["year", "month", "day"]}
                          value={lateDeliveryOnOrAfter}
                          onChange={(date: any) => {
                            setLateDeliveryOnOrAfter(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="lateDeliveryOnOrAfter"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Late Delivery On or Before"
                          value={lateDeliveryOnOrBefore}
                          views={["year", "month", "day"]}
                          onChange={(date: any) => {
                            setLateDeliveryOnOrBefore(
                              date ? new Date(date).toLocaleDateString() : "",
                            );
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="lateDeliveryOnOrBefore"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
                <div className="row"></div>
                <div className="row">
                  <div className="col-md">
                    <div className="input-group">
                      <FormControlLabel
                        label="Exclude PO's with No Remaining Quantity to Release"
                        id="checkedExcludePoNoQtyId"
                        control={
                          <Checkbox
                            checked={checkedExcludePoNoQty}
                            onChange={handleChangeExcludePoNoQty}
                            inputProps={{ "aria-label": "controlled" }}
                            id="checkboxExcludePoNoQtyId"
                          />
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md">
                    <div className="input-group">
                      <FormControlLabel
                        label="Exclude Canceled POs"
                        id="checkedExcludeCanPoId"
                        control={
                          <Checkbox
                            checked={checkedExculdeCanPo}
                            onChange={handleChangeExcludeCanPo}
                            inputProps={{ "aria-label": "controlled" }}
                            id="checkboxExcludeCanPoId"
                          />
                        }
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div style={{ textAlign: "center", paddingTop: "40px" }}>
                    <span>
                      <button
                        type="button"
                        className="btn btn-success"
                        id="searchPurchaseOrderReleaseButton"
                        disabled={isLoading || navigatedBack}
                        onClick={findPurchaseOrderRelease}
                        style={{
                          width: 100,
                          marginBottom: "10px",
                        }}
                      >
                        Find
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {open ? (
            <Dialog open={open} onClose={handleToClose} id="lockedDialog">
              <DialogContent>
                <DialogContentText>
                  The Purchase Order you are about to view is locked. You can no
                  longer create an Order Release for this Purchase Order because
                  pickup dates are in the past or no quantity remains for
                  release. Please contact your merchant.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleToClose} color="primary" autoFocus>
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          ) : (
            <React.Fragment />
          )}
        </div>
        <div id="purchaseOrderReleaseDiv">
          {isLoading || navigatedBack ? (
            <div className="d-flex justify-content-center">
              <div
                className="spinner-border text-primary"
                id="purchaseOrderSpinner"
                role="status"
              ></div>
            </div>
          ) : (
            <table className="table" id="purchaseOrderReleaseTable">
              <thead>
                <tr>
                  <th>Purchase Order ID</th>
                  <th>Ship To</th>
                  <th>Remaining Qty</th>
                  <th>Locked/Unlocked Status</th>
                  <th>Locked Reason</th>
                  <th>Early Ship Date</th>
                  <th>Late Ship Date</th>
                  <th>Freight Terms</th>
                  <th>PO Status</th>
                </tr>
              </thead>
              <tbody>
                {purchaseOrderReleases.map(
                  (purchaseOrderRelease: PurchaseOrderRelease) => (
                    <tr>
                      <td>
                        <Link
                          onClick={() =>
                            routeToPurchaseOrderManager(
                              purchaseOrderRelease?.purchaseOrderId,
                              purchaseOrderRelease?.lockedUnlockedStatus,
                            )
                          }
                        >
                          {purchaseOrderRelease?.purchaseOrderId.startsWith(
                            "FD.",
                          )
                            ? purchaseOrderRelease?.purchaseOrderId.slice(3)
                            : purchaseOrderRelease?.purchaseOrderId}
                        </Link>
                      </td>
                      <td>{purchaseOrderRelease?.shipTo}</td>
                      <td>{purchaseOrderRelease?.remainingQuantity}</td>
                      <td>{purchaseOrderRelease?.lockedUnlockedStatus}</td>
                      <td>{purchaseOrderRelease?.lockedReason}</td>
                      <td>{purchaseOrderRelease?.earlyShipDate}</td>
                      <td>{purchaseOrderRelease?.lateShipDate}</td>
                      <td>{purchaseOrderRelease?.freightTerms}</td>
                      <td>{purchaseOrderRelease?.poStatus}</td>
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div id="alertDialog">
        <Dialog open={openAlert} id="dialog">
          <DialogTitle id="alertDialogTitle">{dialogTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alertDialogText">
              {dialogContent}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              id="alertDialogButton"
              onClick={closeAlertDialog}
              color="primary"
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </section>
  );
};

export default SearchPurchaseOrderForOrderReleasePage;
